import { getEnv, getEnvVariables } from "../utils/env.utils";

export const GoogleTagManager = () => {
	if (getEnv() !== "PROD") {
		return null;
	}

	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-expect-error
	window.dataLayer = window.dataLayer || [];

	function gtag(...args: any[]) {
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-expect-error
		dataLayer.push(args);
	}

	gtag("js", new Date());
	gtag("config", getEnvVariables().GOOGLE_TAG_MANAGER_TAG_ID);

	return <script async src="https://www.googletagmanager.com/gtag/js?id=G-5N09NPQFRH"></script>;
};
